import {
  base_colorAction,
  base_colorAlert,
  base_colorAlertHover,
  input_backgroundDefault,
  input_borderDefault,
  input_borderHover,
  notification_colorAlert,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { transition_fast } from 'ext-ui/style/transitionSpeeds'
import {
  font_family_weight_regular,
  font_lg,
  font_md,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(2)};

  .code-input-label {
    font-family: ${font_family_weight_regular};
    ${font_md};
    color: ${text_colorTextSecondary};
  }

  .code-input-fields {
    display: flex;
    gap: ${spacing(3)};
  }

  .code-input-digit {
    flex: 1;
    min-width: 0;
    height: 52px;
    border: 1px solid ${input_borderDefault};
    border-radius: ${spacing(2)};
    background: ${input_backgroundDefault};
    text-align: center;
    font-family: ${font_family_weight_regular};
    ${font_lg};
    caret-color: ${base_colorAction};
    transition:
      border-color ${transition_fast},
      opacity ${transition_fast};

    &::placeholder {
      opacity: 0;
    }

    &:hover {
      border-color: ${input_borderHover};
    }

    &:focus {
      outline: none;
      border-color: ${base_colorAction};
    }

    &:focus-visible {
      outline: 2px solid ${base_colorAction};
      outline-offset: 2px;
      border-radius: ${spacing(2)};
    }

    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }

  &.error {
    .code-input-digit {
      border-color: ${base_colorAlert};

      &:hover {
        border-color: ${base_colorAlertHover};
      }
    }
  }

  .code-input-error {
    color: ${notification_colorAlert};
    font-family: ${font_family_weight_regular};
    ${font_md};
  }
`
